export default {
    state: {
        // 登录用户信息
        // user: localStorage['user'] ? JSON.parse(localStorage['user']) : null,
        user: sessionStorage['user'] ? JSON.parse(sessionStorage['user']) : null,
        // 用户微信openid
        openid: localStorage['openid'] ? JSON.parse(localStorage['openid']) : '',
        deviceType: localStorage['deviceType'],
        name: localStorage['name'],
        sex: localStorage['sex'],
        staffCode: localStorage['staffCode'],
        jwtToken: localStorage['jwtToken'],
        // member: localStorage['member'] ? JSON.parse(localStorage['member']) : null
        member: sessionStorage['member'] ? JSON.parse(sessionStorage['member']) : null
    },
    mutations: {
        CHANGE_TOKEN: (state, user) => {
            state.user = user
        },
        CHANGE_OPENID: (state, openid) => {
            state.openid = openid
        },
        CHANGE_DEVICETYPE: (state, deviceType) => {
            state.deviceType = deviceType
        },
        CHANGE_NAME: (state, name) => {
            state.name = name
        },
        CHANGE_SEX: (state, sex) => {
            state.sex = sex
        },
        CHANGE_STAFFID: (state, staffCode) => {
            state.staffCode = staffCode
        },
        CHANGE_JWTTOKEN: (state, jwtToken) => {
            state.jwtToken = jwtToken
        },
        CHANGE_MEMBER: (state, member) => {
            state.member = member
        }
    },
    actions: {
        changeToken({ commit }, user) {
            if(user) {
                sessionStorage.setItem('user', JSON.stringify(user))
                localStorage.setItem('user',JSON.stringify(user))
            } else {
                sessionStorage.removeItem('user');
                localStorage.removeItem('user')
            }
            commit('CHANGE_TOKEN', user)
        },
        changeOpenid({ commit }, openid) {
            if(openid) {
                localStorage.setItem('openid',JSON.stringify(openid))
            } else {
                localStorage.removeItem('openid')
            }
            commit('CHANGE_OPENID', openid)
        },
        changeDeviceType({ commit }, deviceType) {
            if(deviceType) {
                localStorage.setItem('openid',JSON.stringify(deviceType))
            } else {
                localStorage.removeItem('deviceType')
            }
            commit('CHANGE_DEVICETYPE', deviceType)
        },
        changeName({ commit }, value) {
            if (value) {
                localStorage.setItem('name', value);
            } else {
                localStorage.removeItem('name');
            }
            commit('CHANGE_NAME', value);
        },
        changeSex({ commit }, value) {
            if (value || value == 0) {
                localStorage.setItem('sex', value);
            } else {
                localStorage.removeItem('sex');
            }
            commit('CHANGE_SEX', value);
        },
        changeStaffId({ commit }, value) {
            if (value) {
                localStorage.setItem('staffCode', value);
            } else {
                localStorage.removeItem('staffCode');
            }
            commit('CHANGE_STAFFID', value);
        },
        changeJwtToken({ commit }, value) {
            if(value) {
                localStorage.setItem('jwtToken', value)
            }else{
                localStorage.removeItem('jwtToken')
            }
            commit('CHANGE_JWTTOKEN', value)
        },
        changeMember({ commit }, member) {
            if(member) {
                sessionStorage.setItem('member',JSON.stringify(member))
                localStorage.setItem('member',JSON.stringify(member))
            } else {
                sessionStorage.removeItem('member')
                localStorage.removeItem('member')
            }
            commit('CHANGE_MEMBER', member)
        },
    }
}


// WEBPACK FOOTER //
// ./src/store/modules/user.js